export const MINUTES_FIRST_INDEX = 1;
export const HOURS_FIRST_INDEX = 3;
export const DAYS_FIRST_INDEX = 5;
export const UNLIMITED_BUTTON_INDEX = -1;
export const UNLIMITED = 'unlimited';

export const PERIODS_VALUE_MAP = [
    1,
    60,
    60 * 24
].map(x => x * 60 * 1000);

export const SEGMENTS_VALUE_MAP = [
    1,
    10,
    60,
    600,
    60 * 24,
    60 * 24 * 10
].map(x => x * 60 * 1000);
